import Modal from "react-modal";
import React, { useEffect, useState } from "react";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { Error } from "Reusable/utils/Toast";
import StarRatings from "react-star-ratings";
import RatingClasses from "./Rating.module.scss";
import { AiOutlineClose } from "react-icons/ai";
import { RateClass } from "Service/parent";
import Moment from "react-moment";
import { SuccessSwal, warningSwal } from "Reusable/utils/Toast";

Modal.setAppElement("#root");

const Rating: React.FC<props> = ({
    modal,
    setModal,
    getDetails,
    getHomePage,
    page,
}) => {
    const {
        handleSubmit,
        reset,
        control,
        register,
        setValue,
        setError,
        clearErrors,
        watch,
        formState: { errors },
    } = useForm<Inputs>();

    const [rating, setRating] = useState(0);

    const closeModal = () => {
        setModal(false);
        reset();
        setRating(0);
    };
    const token = {
        Authorization: `token ${localStorage.getItem("learn2readToken")}`,
    };
    const changeRating = (rating: any) => {
        setRating(rating);
    };
    useEffect(() => {
        setRating(getDetails?.Rating);
        if (getDetails?.Review != "NA") {
            reset({ Review: getDetails.Review });
        }
    }, []);
    // FORM SUBMIT
    const onSubmit: SubmitHandler<Inputs> = async (formdata) => {
        if (rating === 0) {
            return setError("Review", {
                type: "required",
                message: "Rating is required",
            });
        }
        if (formdata.Review.length > 900) {
            return setError("Review", {
                type: "required",
                message: "Review must be at most 900 characters",
            });
        }
        try {
            let cancel = await RateClass(
                "PUT",
                JSON.stringify({ ...formdata, Rating: rating }),
                token,
                getDetails.Scheduled_Classes_StudentID
            );
            if (cancel.Status === 1) {
                closeModal();
                SuccessSwal("Success", cancel.Message);
                getHomePage(page, getDetails.StudentID, true);
            } else {
                warningSwal("Warning", cancel.Message);
            }
        } catch {
            warningSwal("Error", "Something went Wrong try again");
        }
    };

    return (
        <>
            <Modal
                isOpen={modal}
                contentLabel="Modal"
                className={RatingClasses["modal"]}
                // onRequestClose={closeModal}
                overlayClassName={RatingClasses["overlay"]}>
                <div className={RatingClasses["form-wrapper"]}>
                    <button onClick={closeModal}>
                        <AiOutlineClose />
                    </button>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <p>
                            How was your session with {getDetails?.TutorName} on{" "}
                            {getDetails?.CourseName} held on{" "}
                            <Moment format="DD MMM YYYY">
                                {
                                    new Date(
                                        `${getDetails?.Scheduled_StartDate}T${getDetails?.Scheduled_StartTime}`
                                    )
                                }
                            </Moment>
                            ?
                        </p>
                        <div>
                            <StarRatings
                                rating={rating}
                                starRatedColor="#FFDF00"
                                starHoverColor="#FFDF00"
                                changeRating={changeRating}
                                numberOfStars={5}
                                starDimension="30px"
                                name="rating"
                            />
                        </div>
                        <div className={RatingClasses["form-control"]}>
                            {/* <label htmlFor="">Comments</label> */}
                            <textarea
                                rows={10}
                                placeholder="Comments"
                                {...register("Review", {
                                    required: "Review is required",
                                    onChange: (
                                        e: React.ChangeEvent<HTMLTextAreaElement>
                                    ) => {
                                        const val = e.target.value || "";
                                        if (val.length > 900) {
                                            // truncate and set error when user tries to exceed 900 chars
                                            setValue(
                                                "Review",
                                                val.slice(0, 900)
                                            );
                                            setError("Review", {
                                                type: "maxLength",
                                                message:
                                                    "Review must be at most 900 characters",
                                            });
                                        } else {
                                            setValue("Review", val);
                                            // clear the maxLength error if fixed
                                            if (
                                                errors.Review?.type ===
                                                "maxLength"
                                            ) {
                                                clearErrors("Review");
                                            }
                                        }
                                    },
                                })}
                            />
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginTop: 6,
                                }}>
                                {errors.Review ? (
                                    <span style={{ color: "#d9534f" }}>
                                        {errors?.Review?.message}
                                    </span>
                                ) : (
                                    <span />
                                )}
                                <small style={{ color: "rgba(0,0,0,0.6)" }}>
                                    {(watch("Review") || "").length}/900
                                </small>
                            </div>
                        </div>
                        <div className={RatingClasses["buttons"]}>
                            <button className={RatingClasses["submit"]}>
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </Modal>
        </>
    );
};

export default Rating;

interface props {
    modal: any;
    setModal: React.Dispatch<React.SetStateAction<boolean>>;
    getDetails?: any;
    getHomePage?: any;
    page?: any;
}

interface Inputs {
    Rating: number;
    Review: string;
}
